import React, { useState } from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';
import FeedbackCollector from '@atlaskit/feedback-collector';
import { Box, Stack, Text } from '@atlaskit/primitives';

import { type RelatedEntityType } from '../related-entities-api';

import { messages } from './messages';

const FEEDBACK_ENTRYPOINT_ID = '10f4daa4-bcfc-4d42-ae33-92888648d9db';
const FEEDBACK_CONTEXT_ID = 'customfield_10047';
const FEEDBACK_CONTEXT = 'AI Topics Surfaced in Confluence';

type Props = {
	promptText: string;
	userName: string;
	userAccountId: string;
	entityId: string;
	principalEntityType: RelatedEntityType;
};

export const AITopicsFeedbackCollector = ({
	promptText,
	userName,
	userAccountId,
	entityId,
	principalEntityType,
}: Props) => {
	const intl = useIntl();
	const [showFeedbackCollector, setShowFeedbackCollector] = useState(false);

	const toggleFeedbackCollector = () => setShowFeedbackCollector(!showFeedbackCollector);

	const feedbackContext = JSON.stringify({
		name: FEEDBACK_CONTEXT,
		entityId,
		principalEntityType,
	});

	return (
		<Box paddingBlockStart="space.200">
			<Stack space="space.150" alignInline="start">
				<Text color="color.text.subtlest">{promptText}</Text>
				<Button appearance="subtle" spacing="none" onClick={toggleFeedbackCollector}>
					{intl.formatMessage(messages.ai_topics_page_feedback_button_text)}
				</Button>
			</Stack>
			{showFeedbackCollector && (
				<FeedbackCollector
					entrypointId={FEEDBACK_ENTRYPOINT_ID}
					name={userName}
					atlassianAccountId={userAccountId}
					showTypeField={false}
					onClose={toggleFeedbackCollector}
					additionalFields={[
						{
							id: FEEDBACK_CONTEXT_ID,
							value: feedbackContext,
						},
					]}
				/>
			)}
		</Box>
	);
};
